import BtnLoader from 'Components/Common/Loader/BtnLoader';
import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import axios from 'axios';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 400,
    bgcolor: 'background.paper',
    border: 'none',
    borderRadius: 8,
    boxShadow: 24,
    p: 4,
};


const PromoWarningPopup = ({ warnPopupOpen, handleClose, PromoDetails, fetchPromos }) => {
    const [isLoading, setIsLoading] = useState(false)



    const deletePromoCode = () => {
        setIsLoading(true)
        let config = {
            method: 'delete',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/promocode/delete-promo-codes/${PromoDetails?._id}`,
            headers: {}
        };

        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
                setIsLoading(false)
                fetchPromos()
                handleClose()
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false)

            });
    }


    return (
        <Modal
            open={warnPopupOpen}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div className="w-full">
                    <div className="flex flex-col  mb-4">
                        <div className="text-3xl font-bold mr-2">
                            {PromoDetails?.promoCode}
                        </div>
                    </div>
                    <p className="mb-6 tracking-wide">
                        Do you really want to delete this Promo Code?
                    </p>
                    <div className="flex justify-end space-x-4 tracking-wide">
                        <button
                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                        {isLoading
                            ?
                            <button
                                className="px-4 py-2 bg-[#c51369] hover:bg-[#a10f5b] text-white rounded"
                            >
                                <BtnLoader />
                            </button>
                            :
                            <button
                                onClick={deletePromoCode}
                                className="px-4 py-2 bg-[#c51369] hover:bg-[#a10f5b] text-white rounded"
                            >
                                Yes, Delete
                            </button>
                        }
                    </div>
                </div>
            </Box>
        </Modal>
    );
}

export default PromoWarningPopup